var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { SettingsQueryKey } from './queryKey';
export var useUpdateComplianceSettings = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (setting) {
        return api.base
            .put('/api/settings/UpdateComplianceSettings', setting)
            .then(function (res) { return res.data; });
    }, {
        onSuccess: function (_result, setting) {
            queryClient.setQueriesData([SettingsQueryKey.CompanySettings], function (old) {
                if (!(old === null || old === void 0 ? void 0 : old.complianceSettings))
                    return old;
                return __assign(__assign({}, old), { complianceSettings: old.complianceSettings.map(function (cs) {
                        return cs.complianceType === setting.complianceType
                            ? __assign(__assign({}, cs), { shouldTrack: setting.shouldTrack }) : cs;
                    }) });
            });
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { updateComplianceSettings: mutateAsync, isLoading: isLoading };
};
